/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Device_IphoneInputs */

const en_funnel_device_iphone = /** @type {(inputs: Funnel_Device_IphoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iPhone`)
};

const es_funnel_device_iphone = /** @type {(inputs: Funnel_Device_IphoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iPhone`)
};

/**
* | output |
* | --- |
* | "iPhone" |
*
* @param {Funnel_Device_IphoneInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_device_iphone = /** @type {((inputs?: Funnel_Device_IphoneInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Device_IphoneInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_device_iphone(inputs)
	return en_funnel_device_iphone(inputs)
});